import { Component, ViewChild, ElementRef, } from '@angular/core';
import SignaturePad from 'signature_pad';

@Component({
    selector: 'signature-pad',
    templateUrl: './signaturePad.component.html',
    styleUrls: ['./signaturePad.component.scss'],
    standalone: false
})
class SignaturePadComponent
{

    constructor()
    {}
    @ViewChild('canvas') signaturePadEl: ElementRef;

    signatureNeeded: boolean;
    signaturePad: SignaturePad;
    signatureImg: string;

    ngAfterViewInit()
    {
//        this.signatureImg = null;
        this.signaturePad = new SignaturePad(this.signaturePadEl.nativeElement);
    }

    startDrawing
    (
        event: Event
    )
    {
        // works in device not in browser
    }

    moved
    (
        event: Event
    )
    {
        // works in device not in browser
    }

    savePad()
    {
        let base64Data = this.signaturePad.toDataURL();

        this.signatureImg = base64Data;
    }

    /*Undo last step from the signature*/
    undoSign()
    {
        let data = this.signaturePad.toData();

        if (data)
        {
            data.pop(); // remove the last step
            this.signaturePad.fromData(data);
        }
    }

    clearPad()
    {
        this.signaturePad.clear();
    }
}
export  { SignaturePadComponent }